import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CustomField } from "@/components/CustomField";
import { toast } from "sonner";

export function CustomFieldsPrompt() {
  const { user } = useAuth();
  const [fields, setFields] = useState([]);
  const [values, setValues] = useState({});
  const [busy, setBusy] = useState(false);
  const eligible = user && user.role !== "super_admin" && user.application_status === "approved" && !user.needs_member_type;
  useEffect(() => {
    if (!eligible) { return; }
    api.get("/me/missing-fields").then(({ data }) => setFields(data)).catch(() => setFields([]));
  }, [eligible]);
  if (!eligible || !fields.length) return null;
  const save = async () => {
    setBusy(true);
    try {
      await api.post("/me/custom-fields", { values });
      toast.success("Thank you. Your answers were saved.");
      setFields([]);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const done = fields.every((f) => ![undefined, "", null].includes(values[f.key]) && !(Array.isArray(values[f.key]) && !values[f.key].length));
  return (
    <Dialog open>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto [&>button]:hidden" onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()} data-testid="custom-fields-prompt">
        <DialogHeader>
          <DialogTitle>A few new questions</DialogTitle>
          <DialogDescription>The membership form was updated. Please answer these required questions to continue.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4">
          {fields.map((f) => <CustomField key={f.key} field={f} testPrefix="prompt" value={values[f.key]} onChange={(v) => setValues((p) => ({ ...p, [f.key]: v }))} />)}
        </div>
        <div className="mt-2"><Button onClick={save} disabled={busy || !done} className="w-full" data-testid="custom-fields-save">{busy ? "Saving…" : "Save answers"}</Button></div>
      </DialogContent>
    </Dialog>
  );
}
